import { Injectable, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { NotificationActions } from '@next/core-lib/notification';
import { Store } from '@ngrx/store';

import { isCropYearReadOnly } from '../../../store/selectors';
import { DiseaseContext } from '../../components/disease-overview-table.component/models/models';
import { AppState, SprayTypes } from '../../models';
import { DateService } from '../../services/date.service';
import { SprayApplicationSignalStore } from '../signal-store/spray-application-signal-store';

interface SprayApplicationDialogSourceCropField {
  cropFieldId: number;
  cropFieldName: string;
  amountOfHectares: number;
  cropYear?: number;
}

@Injectable({
  providedIn: 'root',
})
export class SprayApplicationDialogService {
  private readonly sprayApplicationStore = inject(SprayApplicationSignalStore);
  private readonly dateService = inject(DateService);
  private readonly appStore = inject<Store<AppState>>(Store);
  private readonly locale = inject(LocaleService);

  openFromCropFields(
    diseaseContext: DiseaseContext,
    cropFields: ReadonlyArray<SprayApplicationDialogSourceCropField>,
    initialSprayType: SprayTypes,
    defaultDate?: Date,
  ): void {
    const cropYear = cropFields[0]?.cropYear;
    if (cropYear == null) {
      this.appStore.dispatch(
        NotificationActions.infoSnackbar({
          message: this.locale.translate('UI.CropYearUnavailableMessage'),
        }),
      );
      return;
    }

    const readOnly = isCropYearReadOnly(cropYear, this.dateService.currentYear());

    const now = this.dateService.now();
    const resolvedDefaultDate = defaultDate
      ? new Date(defaultDate.getUTCFullYear(), defaultDate.getUTCMonth(), defaultDate.getUTCDate(), now.getHours(), now.getMinutes(), 0, 0)
      : now;

    this.sprayApplicationStore.openDialog({
      title: 'sprayApplications.dialogTitle',
      diseaseContext,
      cropFields: cropFields.map((cropField) => ({
        cropFieldId: cropField.cropFieldId,
        cropFieldName: cropField.cropFieldName,
        areaInHectares: cropField.amountOfHectares,
      })),
      defaultDate: resolvedDefaultDate,
      initialSprayType,
      readOnly,
    });
  }
}
